export enum GifTypes {
  KLIPY = 'Klipy',
  GIPHY = 'Giphy',
}
